module.exports = __webpack_public_path__ + "img/cmg2.a0f82846.png";